export enum ClinicType {
  EXPEDITOR = 'expeditor',
  NORTHSIDE = 'northside',
  HEALTH_LOGIX = 'healthlogix',
}
